module.exports = __webpack_public_path__ + "static/media/IMG_9995.370eb5be.jpg";